var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTierImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_13450_1838)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13450_1838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1922 21.7906C20.0656 21.6031 20 21.3781 20 21.1531C20 20.5156 20.5156 20 21.1531 20H26.2766C26.8016 20 27.2938 20.2766 27.5609 20.7266L30.7719 26.075C28.5125 26.3609 26.4922 27.4156 24.9875 28.9766L20.1922 21.7906ZM43.8031 21.7906L39.0125 28.9766C37.5078 27.4156 35.4875 26.3609 33.2281 26.075L36.4391 20.7266C36.7109 20.2766 37.1984 20 37.7234 20H42.8469C43.4844 20 44 20.5156 44 21.1531C44 21.3781 43.9344 21.6031 43.8078 21.7906H43.8031ZM23.75 35.75C23.75 33.562 24.6192 31.4635 26.1664 29.9164C27.7135 28.3692 29.812 27.5 32 27.5C34.188 27.5 36.2865 28.3692 37.8336 29.9164C39.3808 31.4635 40.25 33.562 40.25 35.75C40.25 37.938 39.3808 40.0365 37.8336 41.5836C36.2865 43.1308 34.188 44 32 44C29.812 44 27.7135 43.1308 26.1664 41.5836C24.6192 40.0365 23.75 37.938 23.75 35.75ZM32.3937 31.3016C32.2344 30.9734 31.7703 30.9734 31.6063 31.3016L30.5562 33.4297C30.4906 33.5609 30.3687 33.65 30.2281 33.6688L27.875 34.0109C27.5141 34.0625 27.3734 34.5031 27.6313 34.7609L29.3328 36.4203C29.4359 36.5234 29.4828 36.6641 29.4594 36.8094L29.0562 39.1484C28.9953 39.5047 29.3703 39.7812 29.6938 39.6125L31.7938 38.5062C31.9203 38.4406 32.075 38.4406 32.2016 38.5062L34.3016 39.6125C34.625 39.7812 35 39.5094 34.9391 39.1484L34.5359 36.8094C34.5125 36.6688 34.5594 36.5234 34.6625 36.4203L36.3641 34.7609C36.6266 34.5078 36.4812 34.0672 36.1203 34.0109L33.7719 33.6688C33.6312 33.65 33.5047 33.5562 33.4437 33.4297L32.3937 31.3016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13450_1838",
    x1: 53,
    y1: 56.5,
    x2: -15,
    y2: -15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.175144,
    stopColor: "#F3911D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577404,
    stopColor: "#FEC107"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13450_1838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierImage);
export default __webpack_public_path__ + "static/media/tierImage.e9b5cf9240655498c918a0b68c9cc3d0.svg";
export { ForwardRef as ReactComponent };